module.exports = __webpack_public_path__ + "static/media/induk.2967f085.png";